import axios from "axios";
import isTokenExpired from "./isTokenExp";
import { refreshAccessTokenDirect } from "./refreshToken";


// Axios instance
const SERVER = axios.create({
    // baseURL: process.env.REACT_APP_LIVE_URL, 
    baseURL: 'https://banicoop-server-7cas.onrender.com/api/v1/',
    timeout: 50000, 
    headers: {
        'Content-Type': 'application/json', 
    },
});



SERVER.interceptors.request.use(
  async (config) => {
    try {
      let token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");

      if (token && isTokenExpired(token) && refreshToken) {
        token = await refreshAccessTokenDirect();
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    } catch (error) {
      console.error("Request Interceptor Error:", error);
      throw error;
    }
  },
  (error) => Promise.reject(error)
);


SERVER.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {

        if (error.response) {
            console.error('Response Error:', error.response.data);
            if (error.response.status === 401) {

                localStorage.removeItem('token'); 
                window.location.replace('/auth/login'); 
            }
        } else if (error.request) {

            console.error('No Response Received:', error.request);
        } else {

            console.error('Error Setting Up Request:', error.message);
        }
        return Promise.reject(error); 
    }
);

export default SERVER;
